class DropdownProfile extends React.Component {

    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        this.props.onChange(this.props.field, e.target.value, this.props.address);
    }

    render() {
        var self = this;

        var guest    = this.props.guest;
        var options  = this.props.options;
        var selected = this.props.selected;
        var tabindex = this.props.tabindex || '';

        return (
            <div
                className={'dropdown-profile '+this.props.className}>

                { this.props.title &&
                    <div className='dropdown-profile__title'>
                        {this.props.title}
                    </div>
                }
                
                <select
                    value={selected}
                    required = {this.props.required}
                    onChange={this.onChange}
                    disabled={this.props.disabled}
                    tabindex={tabindex}
                >

                    { options.map((data, i) => {
                        return (
                            <option
                                value={data.option}
                                key={'data.title'+i}>

                                {data.title}
                            </option>
                        );
                    })}
                </select>

            </div>
        );
    }
}

export default DropdownProfile;



// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/DropdownProfile.react.jsx